import React from 'react';

/** Fixed capture affordance. Sits above the tab bar on every screen, inside the thumb arc. */
export function CaptureBar({
  placeholder = 'capture a task, note, question', glyph = '.', action = 'NEW',
  onClick, divider = true, style
}) {
  return (
    <div onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 'var(--bujo-space-3)',
      minHeight: 'var(--bujo-tap-min)', padding: '0 var(--bujo-gutter)',
      borderTop: divider ? '1px solid var(--bujo-rule-hairline)' : 'none',
      background: 'var(--bujo-surface-page)',
      cursor: onClick ? 'pointer' : 'default', ...style
    }}>
      <span style={{
        font: 'var(--bujo-fw-regular) 22px/var(--bujo-lh-tight) var(--bujo-font-mono)',
        color: 'var(--bujo-accent)'
      }}>{glyph}</span>
      <span style={{
        flex: 1,
        font: 'var(--bujo-fw-regular) var(--bujo-fs-event)/var(--bujo-lh-tight) var(--bujo-font-mono)',
        color: 'var(--bujo-text-meta)'
      }}>{placeholder}</span>
      {action ? (
        <span style={{
          font: 'var(--bujo-fw-bold) 9.5px/var(--bujo-lh-tight) var(--bujo-font-mono)',
          letterSpacing: 'var(--bujo-ls-badge)', color: 'var(--bujo-accent)'
        }}>{action}</span>
      ) : null}
    </div>
  );
}
